import { Card, CardContent } from "../ui/card";

export const ProgressChart = ({ testResults, testOrgInfo }) => {
  const allTests = [
    ...testResults.roles,
    ...testResults.team,
    ...testResults.assets,
    ...testResults.services,
    ...testResults.bookings,
    ...testResults.flows,
    ...testResults.revenue,
    ...testResults.payouts,
    ...testResults.account,
    ...testResults.payroll,
    ...testResults.stripeConnect,
    ...testResults.branding,
    ...testResults.waivers,
    ...testResults.reviews,
    ...testResults.checkin,
    ...testResults.leads,
    ...testResults.relations,
    ...testResults.profile,
    ...testResults.preferences,
    ...testResults.calendar,
    ...testResults.webhooks,
    ...testResults.apiKeys,
    ...testResults.activityLog,
    ...testResults.ownerSignin,
    ...testResults.teamSignin,
    ...testResults.signup,
    ...testResults.widgetCheckout,
    ...testResults.waiverFlow,
    ...testResults.qrCodeScanning
  ];

  const total = allTests.length;
  const passed = allTests.filter(t => t.status === 'pass').length;
  const failed = allTests.filter(t => t.status === 'fail').length;
  const warnings = allTests.filter(t => t.status === 'warning').length;
  const percentage = total > 0 ? Math.round((passed / total) * 100) : 0;
  const circumference = 2 * Math.PI * 56;
  const passedLength = (passed / total) * circumference;
  const failedLength = (failed / total) * circumference;

  return (
    <div className="space-y-4">
      {testOrgInfo && (
        <div className="flex items-center gap-4 text-sm">
          <p className="text-cyan-600 font-medium">
            Testing on: {testOrgInfo.name} ({testOrgInfo.slug})
          </p>
        </div>
      )}

      <Card className="bg-gradient-to-r from-cyan-50 to-blue-50 border-2 border-cyan-200">
        <CardContent className="pt-6">
          <div className="flex items-center justify-center gap-8">
            {/* Circle Chart */}
            <div className="relative w-32 h-32">
              <svg className="transform -rotate-90 w-32 h-32">
                <circle
                  cx="64"
                  cy="64"
                  r="56"
                  stroke="#e5e7eb"
                  strokeWidth="10"
                  fill="none"
                />
                {/* Green segment (passed) */}
                <circle
                  cx="64"
                  cy="64"
                  r="56"
                  stroke="#10b981"
                  strokeWidth="10"
                  fill="none"
                  strokeDasharray={`${passedLength} ${circumference}`}
                  strokeLinecap="round"
                />
                {/* Red segment (failed) */}
                {failed > 0 && (
                  <circle
                    cx="64"
                    cy="64"
                    r="56"
                    stroke="#ef4444"
                    strokeWidth="10"
                    fill="none"
                    strokeDasharray={`${failedLength} ${circumference}`}
                    strokeDashoffset={-passedLength}
                    strokeLinecap="round"
                  />
                )}
              </svg>
              <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                <div className="text-center">
                  <div className="text-3xl font-bold text-cyan-600">
                    {percentage}%
                  </div>
                  <div className="text-xs text-gray-600">Health</div>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="flex gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-green-600">
                  {passed}
                </div>
                <div className="text-sm text-gray-600">Passed</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-red-600">
                  {failed}
                </div>
                <div className="text-sm text-gray-600">Failed</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-yellow-600">
                  {warnings}
                </div>
                <div className="text-sm text-gray-600">Warnings</div>
              </div>
            </div>
          </div>

          <div className="mt-4 text-center text-sm text-gray-500">
            📊 Test Coverage: {total} tests | Target: 200-500 tests for production
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
